module.exports = __webpack_public_path__ + "static/ill-1c6c2baa03784d42ee12e1be3fb07a4b.png";